import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DefaultPriceMarginService, IDefaultPriceMargin } from 'src/app/xena-api';

@Component({
    selector: 'app-default-price-margin',
    templateUrl: './default-price-margin.component.html',
    styleUrls: ['./default-price-margin.component.scss'],
    standalone: false
})
export class DefaultPriceMarginComponent implements OnInit {
  @Input() id?: number = null;
  open: boolean = true;
  saving: boolean = false;
  form: UntypedFormGroup;
  defaultPriceMargin: IDefaultPriceMargin = {
    fromAmount: 0,
    margin: 0,
  }

  constructor(private defaultPriceMarginService: DefaultPriceMarginService, private fb: UntypedFormBuilder) {
    this.form = this.fb.group({
      margin: [0],
      fromAmount: [0, [Validators.required, Validators.min(0)]],
    });
  }

  ngOnInit(): void {
    if (isNaN(this.id) || this.id <= 0) {
      this.id = 0;
    }
    if (this.id !== 0) {
      this.getDefaultPriceMargin();
    }
  }

  async getDefaultPriceMargin() {
    this.defaultPriceMargin = await this.defaultPriceMarginService.get(this.id).toPromise();
    this.form.patchValue(this.defaultPriceMargin);
  }

  cancel() {
    this.open = false;
  }

  save() {
    this.saving = true;
    this.defaultPriceMargin = { ...this.defaultPriceMargin, ...this.form.value };
    this.defaultPriceMarginService.save(this.defaultPriceMargin)
      .subscribe(() => { this.open = false; }, () => { this.saving = false; });
  }

}
